<h3 class="title">
  <span class="material-icons">{{ icon }}</span>
  <span>{{ title }}</span>
</h3>
<div class="right-panel">
  <ng-content></ng-content>
</div>
